/* =====================================================================
 * Wunschwort-Poster Editor (PROJ-10) — freies Wort über Foto-Collage
 * =====================================================================
 * Ableitung von letter-poster.js (PROJ-9). Unterschiede: KEINE Buchstaben-
 * Masken — das Wort (max. 12 Zeichen, frei) steht VERTIKAL weiß-massiv
 * (Archivo Black Webfont) am linken Rand ÜBER einer Foto-Collage
 * (Layout-Picker: 1/2/3/4 Fotos). EIN Produkt; Layout-Wechsel behält Fotos.
 * Druck: POSTERFLOW via /api/v1/wunschwort/* (Blanket-Engine-Zweig).
 * ===================================================================== */

(function () {
  'use strict';

  const BACKEND_API_URL = window.WUNSCHWORT_BACKEND_API_URL || 'https://tiles.distantlines.de';
  const MAX_FILE_SIZE_MB = 20;
  const ACCEPTED_TYPES = ['image/jpeg', 'image/png', 'image/heic', 'image/heif'];
  const CROPPER_CSS_URL = 'https://cdn.jsdelivr.net/npm/cropperjs@1.6.2/dist/cropper.min.css';
  const CROPPER_JS_URL = 'https://cdn.jsdelivr.net/npm/cropperjs@1.6.2/dist/cropper.min.js';

  /* ===================================================================
   * LAYOUT-CONFIGS — die 6 V1-Wörter. Geometrie-Sollwerte aus der
   * abgenommenen Preview (Foto-Buchstaben/preview.html, 2026-06-07).
   * texts: 3 freie Zeilen (script1 oben, script2 + caps unten) — Labels
   * sind nur Platzhalter-Beschriftung, Inhalt ist komplett frei.
   * ===================================================================== */
  /* 4 Collage-Layouts (Hochformat) — photos[]-Boxen in %; Wort-Spalte links
     überlappt die Fotos (Referenz: PositivePrints "Liebe Fotocollage"). */
  const WORD_COL = { x: 38, w: 24 };   // horizontale Wort-Zone; vertikal = exakt der Foto-Extent (Dominik 07.06.)
  const PHOTO_TOP = 6, PHOTO_BOTTOM = 86, PHOTO_BOTTOM_OHNE_TEXT = 93;
  function sublineLeer() {
    return !(state.texts || []).some(function (t) { return t.content && String(t.content).trim(); });
  }
  /* Foto-Boxen des Layouts — bei leerer Subline wächst die Fläche nach unten */
  function effectivePhotoBoxes() {
    var boxes = activeLayout.photos.map(function (p) { return { x: p.x, y: p.y, w: p.w, h: p.h }; });
    if (sublineLeer()) {
      var f = (PHOTO_BOTTOM_OHNE_TEXT - PHOTO_TOP) / (PHOTO_BOTTOM - PHOTO_TOP);
      boxes.forEach(function (b) { b.y = PHOTO_TOP + (b.y - PHOTO_TOP) * f; b.h = b.h * f; });
    }
    return boxes;
  }
  const LAYOUTS = {
    'vollbild': {
      id: 'vollbild', name: '1 Foto', aspect: '3 / 4', blanketColor: '#ffffff',
      photos: [{ x: 11, y: 6, w: 78, h: 80 }],
      texts: [
        { content: 'Du und ich. Für immer zusammen.', label: 'Zeile unten', free: true, x: 50, y: 92.5, font: 'Great Vibes', weight: 400, size: 4.2, color: '#3a3a3a' }
      ]
    },
    'zwei': {
      id: 'zwei', name: '2 Fotos', aspect: '3 / 4', blanketColor: '#ffffff',
      photos: [{ x: 11, y: 6, w: 78, h: 39 }, { x: 11, y: 47, w: 78, h: 39 }],
      texts: [
        { content: 'Du und ich. Für immer zusammen.', label: 'Zeile unten', free: true, x: 50, y: 92.5, font: 'Great Vibes', weight: 400, size: 4.2, color: '#3a3a3a' }
      ]
    },
    'drei': {
      id: 'drei', name: '3 Fotos', aspect: '3 / 4', blanketColor: '#ffffff',
      photos: [{ x: 11, y: 6, w: 78, h: 25.4 }, { x: 11, y: 33.3, w: 78, h: 25.4 }, { x: 11, y: 60.6, w: 78, h: 25.4 }],
      texts: [
        { content: 'Du und ich. Für immer zusammen.', label: 'Zeile unten', free: true, x: 50, y: 92.5, font: 'Great Vibes', weight: 400, size: 4.2, color: '#3a3a3a' }
      ]
    },
    'vier': {
      id: 'vier', name: '4 Fotos', aspect: '3 / 4', blanketColor: '#ffffff',
      photos: [{ x: 11, y: 6, w: 38, h: 39 }, { x: 51, y: 6, w: 38, h: 39 }, { x: 11, y: 47, w: 38, h: 39 }, { x: 51, y: 47, w: 38, h: 39 }],
      texts: [
        { content: 'Du und ich. Für immer zusammen.', label: 'Zeile unten', free: true, x: 50, y: 92.5, font: 'Great Vibes', weight: 400, size: 4.2, color: '#3a3a3a' }
      ]
    }
  };

  const CAM = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"/><circle cx="12" cy="13" r="4"/></svg>';

  /* ===================================================================
   * Buchstaben-Geometrie — MUSS dem Server-Render 1:1 entsprechen
   * (geteilte Formeln Editor=Server — wordFontCqw + WORD_COL + LAYOUTS).
   * =================================================================== */
  /* Vertikales Wunschwort — Größenformel MUSS dem Server-Render entsprechen:
     Buchstabengröße schrumpft mit Wortlänge (1 Zeichen groß, 12 klein). */
  /* Buchstabengröße füllt die Wort-Zone VERTIKAL aus (aspect-bewusst, cqw =
     %% der Stage-BREITE → Höhe = 100/ratio cqw). Formel = Server (print-mode). */
  function wordFontCqw(len, ratio, zoneH) {
    var availCqw = (zoneH / 100) * (100 / (ratio || 0.75)) * 0.97;
    return Math.min(26, availCqw / (Math.max(1, len) * 1.04));
  }
  function buildWordColumn(word) {
    // Wort-Zone vertikal = exakter Foto-Extent (symmetrisch innerhalb der Fotos)
    var boxes = effectivePhotoBoxes();
    var top = Math.min.apply(null, boxes.map(function (b) { return b.y; }));
    var bottom = Math.max.apply(null, boxes.map(function (b) { return b.y + b.h; }));
    var zoneH = bottom - top;
    var col = document.createElement('div');
    col.className = 'ww-word';
    col.style.cssText = 'position:absolute;left:' + WORD_COL.x + '%;top:' + top + '%;width:' + WORD_COL.w + '%;height:' + zoneH +
      '%;display:flex;flex-direction:column;align-items:center;justify-content:center;z-index:6;pointer-events:none;';
    var rp = String(activeLayout && activeLayout.aspect || '3 / 4').split('/');
    var ratio = (parseFloat(rp[0]) || 3) / (parseFloat(rp[1]) || 4);
    var size = wordFontCqw(word.length, ratio, zoneH);
    word.split('').forEach(function (ch) {
      var sp = document.createElement('span');
      sp.textContent = ch;
      sp.style.cssText = "font-family:'" + (state.word_font || 'Archivo Black') + "',sans-serif;color:" + (state.word_color || '#ffffff') + ";font-size:" + size + "cqw;line-height:1.04;" +
        'text-shadow:0 0 0.25em rgba(0,0,0,0.18),0 0.05em 0.12em rgba(0,0,0,0.22);';
      col.appendChild(sp);
    });
    return col;
  }

  /* ===================================================================
   * Modul-State (single instance — eine Section pro -gestalten-Page)
   * =================================================================== */
  let root, stage, assets, sectionId, layoutId;
  let activeLayout, currentGrid;
  const state = { word: 'LIEBE', word_font: 'Archivo Black', word_color: '#ffffff', texts: [], bgColor: '#ffffff', design_color: '#ffffff', paper_size: '', product_type: '', variant_id: '', frame_color: 'brown' };
  const photoSrcs = {};   // slot-index -> objectURL (Vorschau)
  const slotData = {};    // slot-index -> { user_image_url, crop:{x,y,w,h}|null }
  const cropSource = {};  // slot-index -> dataURL/objectURL fürs Crop-Modal

  /* Crop in der Stage anwenden (Spiegel der Server-Logik). crop = 0..1 {x,y,w,h}. */
  function applyCropStyles(img, crop) {
    if (!crop) { img.removeAttribute('style'); return; }
    img.style.inset = 'auto';
    img.style.position = 'absolute';
    img.style.left = (-(crop.x / crop.w) * 100) + '%';
    img.style.top = (-(crop.y / crop.h) * 100) + '%';
    img.style.width = (100 / crop.w) + '%';
    img.style.height = (100 / crop.h) + '%';
    img.style.maxWidth = 'none';
    img.style.objectFit = 'cover';
  }

  /* ===================================================================
   * Stage-Rendering
   * =================================================================== */
  function deepCloneLayout(l) {
    var c = Object.assign({}, l);
    if (l.row) c.row = Object.assign({}, l.row);
    c.texts = l.texts.map(function (t) { return Object.assign({}, t); });
    return c;
  }

  /* Stage-Proportion an die gewählte Postergröße koppeln (Fotoposter-Pattern:
     40x30=4:3, 50x40=5:4, 70x50=7:5, 100x70=10:7). Fotos/Texte/Crops bleiben
     erhalten — nur Geometrie wird neu gerechnet und die Stage neu gerendert. */
  function syncStageToSize() {
    if (!activeLayout || !state.paper_size) return;
    var d = parsePosterDim(state.paper_size);
    // Wunschwort ist IMMER Hochformat: kurze Kante = Breite
    var aspect = Math.min(d.w, d.h) + ' / ' + Math.max(d.w, d.h);
    if (activeLayout.aspect === aspect) return;
    activeLayout.aspect = aspect;
    renderStage();
  }

  function loadLayout(id) {
    activeLayout = deepCloneLayout(LAYOUTS[id] || LAYOUTS['zwei']);
    if (state.paper_size) {
      var d = parsePosterDim(state.paper_size);
      // Hochformat: kurze Kante = Breite
      activeLayout.aspect = Math.min(d.w, d.h) + ' / ' + Math.max(d.w, d.h);
    }
    state.texts = activeLayout.texts;
    // BEWUSST KEIN photoSrcs/slotData-Reset — Fotos bleiben beim Collage-Wechsel (PROJ-10-Spec)
    renderStage();
  }

  function renderStage() {
    var layout = activeLayout;
    stage.style.setProperty('--collage-aspect', layout.aspect);
    var wrap = stage.closest('.wunschwort-stage-flat');
    if (wrap) wrap.classList.toggle('is-portrait', layout.format === 'portrait');

    var grid = document.createElement('div');
    grid.className = 'collage-grid no-panel';
    grid.style.setProperty('--blanket-color', state.bgColor);
    currentGrid = grid;

    var __boxes = effectivePhotoBoxes();
    layout.photos.forEach(function (ph, i) {
      ph = __boxes[i] || ph;
      var s = document.createElement('div');
      s.className = 'photo-slot';
      s.setAttribute('data-slot-index', i);
      if (photoSrcs[i]) {
        s.classList.add('has-photo');
        s.innerHTML = '<img class="photo" src="' + photoSrcs[i] + '" alt="">';
        var im = s.querySelector('img.photo');
        if (im && slotData[i] && slotData[i].crop) applyCropStyles(im, slotData[i].crop);
      } else {
        s.innerHTML = '<div class="cta">' + CAM + '<span>Foto</span></div>';
      }
      s.title = photoSrcs[i] ? 'Klicken: Foto zuschneiden' : 'Klicken: eigenes Foto laden';
      s.style.position = 'absolute';
      s.style.left = ph.x + '%'; s.style.top = ph.y + '%';
      s.style.width = ph.w + '%'; s.style.height = ph.h + '%';
      s.style.zIndex = 2 + i;
      s.style.cursor = 'pointer';
      s.addEventListener('click', function () {
        if (photoSrcs[i]) openCropModal(i, s); else pickPhotoFor(i, s);
      });
      grid.appendChild(s);

    });

    // Wunschwort-Spalte (vertikal, weiß-massiv) über den Fotos
    grid.appendChild(buildWordColumn(state.word || ''));

    state.texts.forEach(function (t, ti) {
      var el = document.createElement('div');
      el.className = 'text-slot';
      el.setAttribute('data-text-index', ti);
      el.style.fontFamily = "'" + (t.font || 'Playfair Display') + "', serif";
      el.style.fontWeight = t.weight || 400;
      el.style.color = t.color || '#28292d';
      el.style.fontSize = (t.size || 5) + 'cqw';
      if (t.upper) el.style.textTransform = 'uppercase';
      if (t.spacing) el.style.letterSpacing = t.spacing;
      el.textContent = t.content;
      el.style.position = 'absolute';
      el.style.left = (t.x != null ? t.x : 50) + '%';
      el.style.top = (t.y != null ? t.y : 50) + '%';
      el.style.transform = 'translate(-50%, -50%)';
      el.style.zIndex = 7; el.style.whiteSpace = 'nowrap'; el.style.justifyContent = 'center';
      grid.appendChild(el);
    });

    stage.innerHTML = '';
    stage.appendChild(grid);
  }

  /* ===================================================================
   * Foto-Upload pro Slot — objectURL-Sofortvorschau + S3 im Hintergrund
   * (1:1 Kissen-Pattern)
   * =================================================================== */
  let _uploadInput = null;
  function pickPhotoFor(i, slotEl) {
    if (!_uploadInput) {
      _uploadInput = document.createElement('input');
      _uploadInput.type = 'file'; _uploadInput.accept = 'image/jpeg,image/png,image/heic,image/heif';
      _uploadInput.style.display = 'none'; document.body.appendChild(_uploadInput);
    }
    const inp = _uploadInput; inp.value = ''; inp.multiple = false;
    inp.onchange = function () {
      const f = inp.files && inp.files[0];
      if (f) setSlotImage(i, f, slotEl, function () { openCropModal(i, slotEl); });
    };
    inp.click();
  }

  function downscaleForCrop(file, maxSide) {
    return new Promise(function (resolve) {
      const url = URL.createObjectURL(file);
      const im = new Image();
      im.onload = function () {
        const w = im.naturalWidth, h = im.naturalHeight;
        if (!w || !h || (w <= maxSide && h <= maxSide)) { resolve(url); return; }
        const scale = maxSide / Math.max(w, h);
        const c = document.createElement('canvas');
        c.width = Math.round(w * scale); c.height = Math.round(h * scale);
        c.getContext('2d').drawImage(im, 0, 0, c.width, c.height);
        URL.revokeObjectURL(url);
        resolve(c.toDataURL('image/jpeg', 0.9));
      };
      im.onerror = function () { resolve(url); };
      im.src = url;
    });
  }

  function validateFile(f) {
    if (!ACCEPTED_TYPES.includes(f.type) && !/\.(jpg|jpeg|png|heic|heif)$/i.test(f.name)) {
      alert('Format nicht unterstützt — bitte JPG, PNG oder HEIC'); return false;
    }
    if (f.size > MAX_FILE_SIZE_MB * 1024 * 1024) {
      alert('Datei zu groß — max ' + MAX_FILE_SIZE_MB + ' MB'); return false;
    }
    return true;
  }

  function setSlotImage(i, file, slotEl, onReady) {
    if (!validateFile(file)) return;
    const url = URL.createObjectURL(file);
    photoSrcs[i] = url;
    cropSource[i] = url;
    slotData[i] = slotData[i] || {};
    slotData[i].crop = null;

    if (!slotEl) slotEl = stage.querySelector('[data-slot-index="' + i + '"]');
    if (slotEl) {
      let img = slotEl.querySelector('img.photo');
      if (!img) {
        slotEl.classList.add('has-photo');
        const cta = slotEl.querySelector('.cta'); if (cta) cta.remove();
        img = document.createElement('img'); img.className = 'photo';
        slotEl.insertBefore(img, slotEl.firstChild);
      }
      img.removeAttribute('style');
      img.src = url;
      slotEl.title = 'Klicken: Foto zuschneiden';
    }
    var ctaOverlay = stage.querySelector('.letter-cta[data-cta-for="' + i + '"]');
    if (ctaOverlay) ctaOverlay.remove();
    refreshSlotListItem(i);

    uploadToS3(file).then(function (publicUrl) {
      slotData[i].user_image_url = publicUrl;
    }).catch(function (err) {
      console.error('[wunschwort] S3 upload failed for slot ' + i, err);
    });

    downscaleForCrop(file, 2400).then(function (durl) {
      cropSource[i] = durl;
      if (typeof onReady === 'function') onReady();
    });
  }

  async function uploadToS3(file) {
    const presignedResp = await fetch(BACKEND_API_URL + '/api/v1/upload/presigned-url/', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ filename: file.name || 'letter-photo.jpg', content_type: file.type || 'image/jpeg' }),
    });
    if (!presignedResp.ok) throw new Error('Presigned URL failed: HTTP ' + presignedResp.status);
    const presigned = await presignedResp.json();
    const uploadUrl = presigned.uploadUrl || presigned.upload_url;
    const publicUrl = presigned.publicUrl || presigned.public_url;
    const fields = presigned.fields || {};
    if (!uploadUrl || !publicUrl) throw new Error('Invalid presigned response');
    const formData = new FormData();
    Object.keys(fields).forEach(function (k) { formData.append(k, fields[k]); });
    formData.append('file', file);
    const uploadResp = await fetch(uploadUrl, { method: 'POST', body: formData });
    if (!uploadResp.ok && uploadResp.status !== 204) throw new Error('S3 upload failed: HTTP ' + uploadResp.status);
    return publicUrl;
  }

  /* ===================================================================
   * Crop-Modal — 1:1 Kissen/Decken-Pattern (Cropper.js on-demand).
   * Aspekt = Letter-Box-Verhältnis in px (schmales I = schmaler Crop).
   * =================================================================== */
  let _cropper = null, _cropBackdrop = null, _cropSlotIndex = null, _cropInitialRatio = null;
  function ensureCropper() {
    return new Promise(function (resolve, reject) {
      if (window.Cropper) { resolve(); return; }
      if (!document.querySelector('link[data-cropper]')) {
        const lk = document.createElement('link');
        lk.rel = 'stylesheet'; lk.href = CROPPER_CSS_URL; lk.setAttribute('data-cropper', '1');
        document.head.appendChild(lk);
      }
      const sc = document.createElement('script');
      sc.src = CROPPER_JS_URL;
      sc.onload = function () { resolve(); };
      sc.onerror = function () { reject(new Error('Cropper konnte nicht geladen werden')); };
      document.head.appendChild(sc);
    });
  }
  function buildCropBackdrop() {
    const bd = document.createElement('div');
    bd.className = 'collage-cropper-modal-backdrop';
    bd.innerHTML =
      '<div class="collage-cropper-modal">' +
        '<div class="collage-cropper-modal-header"><h3>Foto zuschneiden</h3></div>' +
        '<div class="collage-cropper-wrapper"><img alt=""></div>' +
        '<p class="collage-cropper-help">Verschiebe den Rahmen oder seine Ecken, um dein Bild zuzuschneiden. Mit Mausrad oder Slider kannst du zoomen.</p>' +
        '<div class="collage-cropper-zoom-bar">' +
          '<button type="button" class="collage-zoom-btn collage-zoom-out" aria-label="Verkleinern">−</button>' +
          '<input type="range" class="collage-zoom-slider" min="100" max="200" value="100" aria-label="Zoom">' +
          '<button type="button" class="collage-zoom-btn collage-zoom-in" aria-label="Vergrößern">+</button>' +
        '</div>' +
        '<div class="collage-cropper-modal-footer">' +
          '<button type="button" class="collage-crop-cancel">Abbrechen</button>' +
          '<button type="button" class="primary collage-crop-apply">Zuschneiden &amp; übernehmen</button>' +
        '</div>' +
      '</div>';
    document.body.appendChild(bd);
    bd.addEventListener('click', function (e) { if (e.target === bd) closeCropModal(); });
    bd.querySelector('.collage-crop-cancel').addEventListener('click', closeCropModal);
    bd.querySelector('.collage-crop-apply').addEventListener('click', applyCropFromModal);
    const zs = bd.querySelector('.collage-zoom-slider');
    if (zs) zs.addEventListener('input', function () {
      if (!_cropper || !_cropInitialRatio) return;
      _cropper.zoomTo(_cropInitialRatio * (parseInt(this.value, 10) / 100));
    });
    bd.querySelector('.collage-zoom-in').addEventListener('click', function () { if (_cropper) _cropper.zoom(0.1); });
    bd.querySelector('.collage-zoom-out').addEventListener('click', function () { if (_cropper) _cropper.zoom(-0.1); });
    return bd;
  }
  function openCropModal(i, slotEl) {
    _cropSlotIndex = i;
    if (!cropSource[i]) { pickPhotoFor(i, slotEl); return; }
    ensureCropper().then(function () {
      if (!_cropBackdrop) _cropBackdrop = buildCropBackdrop();
      _cropBackdrop.classList.add('visible');
      document.body.style.overflow = 'hidden';
      initCropperImage(i, slotEl);
    }).catch(function (e) { console.error(e); alert('Crop-Editor konnte nicht geladen werden.'); });
  }
  function initCropperImage(i, slotEl) {
    const img = _cropBackdrop.querySelector('.collage-cropper-wrapper img');
    if (_cropper) { _cropper.destroy(); _cropper = null; }
    let aspect = NaN;
    const el = slotEl || stage.querySelector('[data-slot-index="' + i + '"]');
    if (el) { const r = el.getBoundingClientRect(); if (r.width && r.height) aspect = r.width / r.height; }
    let _built = false;
    img.onload = function () {
      if (_built) return; _built = true;
      requestAnimationFrame(function () {
        _cropper = new Cropper(img, {
          aspectRatio: aspect || NaN,
          viewMode: 1, autoCropArea: 1,
          movable: true, zoomable: true, rotatable: false, scalable: false,
          cropBoxResizable: true, responsive: false, background: false, modal: true,
          dragMode: 'none', toggleDragModeOnDblclick: false, // kein Neu-Aufziehen ausserhalb der Box (Clarity 10.08.)
          minCropBoxWidth: 60, minCropBoxHeight: 60,
          wheelZoomRatio: 0.08,
          ready: function () {
            const cd = _cropper.getCanvasData();
            _cropInitialRatio = cd.naturalWidth ? (cd.width / cd.naturalWidth) : null;
            const zs = _cropBackdrop && _cropBackdrop.querySelector('.collage-zoom-slider');
            if (zs) zs.value = 100;
            const c = slotData[i] && slotData[i].crop;
            if (c) {
              const d = _cropper.getImageData();
              _cropper.setData({ x: c.x * d.naturalWidth, y: c.y * d.naturalHeight, width: c.w * d.naturalWidth, height: c.h * d.naturalHeight });
            }
          },
          zoom: function (ev) {
            if (!_cropInitialRatio) return;
            const zs = _cropBackdrop && _cropBackdrop.querySelector('.collage-zoom-slider');
            if (zs) { const pct = Math.round((ev.detail.ratio / _cropInitialRatio) * 100); zs.value = Math.max(100, Math.min(200, pct)); }
          }
        });
      });
    };
    img.src = cropSource[i];
    if (img.complete && img.naturalWidth) img.onload();
  }
  function applyCropFromModal() {
    if (!_cropper || _cropSlotIndex == null) { closeCropModal(); return; }
    const data = _cropper.getData();
    const id = _cropper.getImageData();
    const NW = id.naturalWidth || 1, NH = id.naturalHeight || 1;
    const crop = {
      x: Math.max(0, Math.min(1, data.x / NW)),
      y: Math.max(0, Math.min(1, data.y / NH)),
      w: Math.max(0.01, Math.min(1, data.width / NW)),
      h: Math.max(0.01, Math.min(1, data.height / NH))
    };
    slotData[_cropSlotIndex] = slotData[_cropSlotIndex] || {};
    slotData[_cropSlotIndex].crop = crop;
    const el = stage.querySelector('[data-slot-index="' + _cropSlotIndex + '"]');
    if (el) { const im = el.querySelector('img.photo'); if (im) applyCropStyles(im, crop); }
    closeCropModal();
  }
  function closeCropModal() {
    if (_cropper) { _cropper.destroy(); _cropper = null; }
    if (_cropBackdrop) _cropBackdrop.classList.remove('visible');
    document.body.style.overflow = '';
    _cropSlotIndex = null;
  }

  /* ===================================================================
   * "Deine Fotos" — Pro-Buchstabe-Liste im Layout-Tab (Decken-Pattern)
   * =================================================================== */
  function buildPhotoControls() {
    const host = document.getElementById('wunschwort-photo-controls-' + sectionId);
    if (!host) return;
    const ul = document.createElement('ul');
    ul.className = 'collage-photo-slot-list';
    activeLayout.photos.forEach(function (ph, i) {
      const li = document.createElement('li');
      li.className = 'collage-photo-slot-item';
      li.setAttribute('data-slot-index', i);

      const thumb = document.createElement('span');
      thumb.className = 'collage-photo-slot-thumb';
      const timg = document.createElement('img'); timg.alt = '';
      timg.src = photoSrcs[i] || (assets && assets.placeholder) || '';
      thumb.appendChild(timg);

      const label = document.createElement('span');
      label.className = 'collage-photo-slot-label';
      label.textContent = 'Foto ' + (i + 1);

      const btn = document.createElement('label');
      btn.className = 'photo-upload-button collage-photo-slot-upload';
      const span = document.createElement('span');
      span.textContent = photoSrcs[i] ? 'Ändern' : 'Foto hochladen';
      const inp = document.createElement('input');
      inp.type = 'file'; inp.accept = 'image/jpeg,image/png,image/heic,image/heif';
      (function (idx) {
        inp.addEventListener('change', function (e) {
          const f = e.target.files && e.target.files[0];
          if (f) setSlotImage(idx, f, null, function () { openCropModal(idx, null); });
          e.target.value = '';
        });
        thumb.addEventListener('click', function () { if (photoSrcs[idx]) openCropModal(idx, null); });
      })(i);
      btn.appendChild(span); btn.appendChild(inp);

      li.appendChild(thumb); li.appendChild(label); li.appendChild(btn);
      ul.appendChild(li);
    });
    host.innerHTML = '';
    host.appendChild(ul);
  }

  function refreshSlotListItem(i) {
    const li = document.querySelector('.collage-photo-slot-item[data-slot-index="' + i + '"]');
    if (!li) return;
    const ti = li.querySelector('.collage-photo-slot-thumb img');
    if (ti && photoSrcs[i]) ti.src = photoSrcs[i];
    const sp = li.querySelector('.collage-photo-slot-upload span');
    if (sp && photoSrcs[i]) sp.textContent = 'Ändern';
  }

  function buildTextFields() {
    const host = document.getElementById('wunschwort-text-fields-' + sectionId);
    if (!host) return;
    host.innerHTML = '';
    // Pflichtfeld: das Wunschwort (max. 12 Zeichen, wird groß & uppercase gesetzt)
    (function () {
      const wrap = document.createElement('div'); wrap.className = 'wunschwort-text-field';
      const lab = document.createElement('label');
      lab.setAttribute('for', 'wunschwort-word-' + sectionId);
      lab.textContent = 'Dein Wort (max. 12 Zeichen)';
      const row = document.createElement('div'); row.className = 'collage-text-row';
      const inp = document.createElement('input');
      inp.type = 'text'; inp.id = 'wunschwort-word-' + sectionId;
      inp.value = state.word; inp.autocomplete = 'off'; inp.maxLength = 12;
      inp.addEventListener('input', function () {
        state.word = inp.value.toUpperCase();
        const old = stage.querySelector('.ww-word');
        if (old) old.replaceWith(buildWordColumn(state.word));
      });
      const col = document.createElement('input');
      col.type = 'color'; col.value = state.word_color;
      col.addEventListener('input', function () {
        state.word_color = col.value;
        const old = stage.querySelector('.ww-word');
        if (old) old.replaceWith(buildWordColumn(state.word));
      });
      row.appendChild(inp); row.appendChild(col);
      wrap.appendChild(lab); wrap.appendChild(row);
      host.appendChild(wrap);
    })();
    state.texts.forEach(function (t, i) {
      const wrap = document.createElement('div'); wrap.className = 'wunschwort-text-field';
      const lab = document.createElement('label');
      lab.setAttribute('for', 'wunschwort-text-' + i + '-' + sectionId);
      lab.textContent = t.label || 'Text';
      const row = document.createElement('div'); row.className = 'collage-text-row';
      const inp = document.createElement('input');
      inp.type = 'text'; inp.id = 'wunschwort-text-' + i + '-' + sectionId;
      inp.value = t.content; inp.autocomplete = 'off'; inp.maxLength = 40;
      inp.addEventListener('input', function () {
        var warLeer = sublineLeer();
        t.content = inp.value;
        if (sublineLeer() !== warLeer) { renderStage(); return; }   // Fotos + Wort wachsen/schrumpfen
        const el = stage.querySelector('.text-slot[data-text-index="' + i + '"]');
        if (el) el.textContent = inp.value;
      });
      // Farbfeld pro Zeile — Decken-Engine-Pattern
      const col = document.createElement('input');
      col.type = 'color'; col.value = t.color || '#3a3a3a';
      col.addEventListener('input', function () {
        t.color = col.value;
        const el = stage.querySelector('.text-slot[data-text-index="' + i + '"]');
        if (el) el.style.color = col.value;
      });
      row.appendChild(inp); row.appendChild(col);
      wrap.appendChild(lab); wrap.appendChild(row);
      host.appendChild(wrap);
    });
  }

  /* ===================================================================
   * Wort-Picker (Kissen-PROJ-6-Pattern): Thumbnails, wechselt Wort UND
   * Shopify-Produkt (Mapping aus #wunschwort-products-<sectionId>).
   * =================================================================== */
  let LAYOUT_PRODUCTS = {};
  function renderLayoutThumb(layout, host) {
    const thumbStage = document.createElement('div');
    thumbStage.className = 'collage-stage is-thumb';
    thumbStage.style.setProperty('--collage-aspect', layout.aspect);
    host.style.backgroundColor = layout.blanketColor || '#f1e8dd';
    thumbStage.style.height = '100%'; thumbStage.style.width = 'auto';
    const grid = document.createElement('div');
    grid.className = 'collage-grid no-panel';
    grid.style.setProperty('--blanket-color', layout.blanketColor || '#f1e8dd');
    layout.photos.forEach(function (b) {
      const s = document.createElement('div');
      s.style.cssText = 'position:absolute;left:' + b.x + '%;top:' + b.y + '%;width:' + b.w + '%;height:' + b.h + '%;background:#d8d2c7;';
      grid.appendChild(s);
    });
    const w = document.createElement('div');
    w.style.cssText = 'position:absolute;left:' + WORD_COL.x + '%;top:' + WORD_COL.y + '%;width:' + WORD_COL.w + '%;height:' + WORD_COL.h + "%;display:flex;flex-direction:column;align-items:center;justify-content:center;color:#fff;font-family:'Archivo Black',sans-serif;font-size:3.4cqw;line-height:1.05;";
    'ABC'.split('').forEach(function (ch) { const sp = document.createElement('span'); sp.textContent = ch; w.appendChild(sp); });
    grid.appendChild(w);
    thumbStage.appendChild(grid);
    host.appendChild(thumbStage);
  }

  function switchProduct(id) { /* EIN Produkt — Collage-Picker wechselt nur das Layout */ }

  function buildLayoutPicker() {
    const host = document.getElementById('wunschwort-layout-picker-' + sectionId);
    if (!host) return;
    host.innerHTML = '';
    const ul = document.createElement('ul');
    ul.className = 'collage-template-picker';
    Object.keys(LAYOUTS).forEach(function (id) {
      const l = LAYOUTS[id];
      const li = document.createElement('li');
      const a = document.createElement('a');
      a.href = '#';
      a.className = 'collage-template' + (id === layoutId ? ' current' : '');
      a.setAttribute('aria-label', l.name);
      const thumb = document.createElement('span');
      thumb.className = 'collage-template-thumb' + (l.format === 'landscape' ? ' is-landscape' : '');
      renderLayoutThumb(l, thumb);
      const name = document.createElement('span');
      name.className = 'collage-template-name';
      name.textContent = l.name;
      a.appendChild(thumb); a.appendChild(name);
      a.addEventListener('click', function (e) {
        e.preventDefault();
        if (id === layoutId) return;
        ul.querySelectorAll('.collage-template').forEach(function (x) { x.classList.remove('current'); });
        a.classList.add('current');
        layoutId = id;
        loadLayout(id);          // resettet Fotos/Texte/Crops (wie Decke/Kissen)
        buildPhotoControls();
        buildTextFields();
        switchProduct(id);
      });
      li.appendChild(a); ul.appendChild(li);
    });
    host.appendChild(ul);
  }

  var formatDefaulted = false;
  function initTabSwitching() {
    const tabs = root.querySelectorAll('.main__switcher > ul > li > a[data-tab]');
    const panels = ['layout__wrapper', 'text__wrapper', 'produkt__wrapper'];
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function (e) {
        e.preventDefault();
        const target = tab.dataset.tab;
        tabs.forEach(function (t) { t.classList.remove('current'); });
        tab.classList.add('current');
        panels.forEach(function (cls) {
          const el = root.querySelector('.' + cls);
          if (el) el.style.display = (cls === target) ? '' : 'none';
        });
        // Produkt-Tab-Default (Dominik 21.07.): erster Klick -> Holzrahmen (data-id=2);
        // Schwarz + 50x70 sind im Markup bereits .current.
        if (target === 'produkt__wrapper' && !formatDefaulted) {
          formatDefaulted = true;
          var framed = root.querySelector('.tab__switcher a[data-id="2"]:not(.current)');
          if (framed) framed.click();
        }
        // Mobiles Hochscrollen zur Tab-Leiste (<=991px), alle Optionen sichtbar.
        if (window.matchMedia('(max-width: 991px)').matches) {
          var sw = tab.closest('.main__switcher');
          if (sw) sw.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });
  }
  function initWeiterNav() {
    root.querySelectorAll('.weiter-btn[data-target-tab]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var link = root.querySelector('.main__switcher > ul > li > a[data-tab="' + btn.dataset.targetTab + '"]');
        if (link) link.click();
      });
    });
  }

  /* ===================================================================
   * Produkt-Tab — 1:1 Fotoposter-Schema (photo.js-Konventionen):
   * .tab__switcher a[data-id|data-type] schaltet .el__format + .benefits-box,
   * .size__picker a[data-size|data-variant-id] wählt Variante,
   * a[data-frame-color] die Rahmenfarbe (nur Format 2 sichtbar).
   * =================================================================== */
  function formatPrice(cents) {
    return (parseInt(cents, 10) / 100).toFixed(2).replace('.', ',');
  }
  function syncVariantFromSize(a) {
    state.paper_size = a.getAttribute('data-size') || '';
    state.variant_id = a.getAttribute('data-variant-id') || '';
    var variantInput = document.getElementById('wunschwort-variant-id-' + sectionId);
    if (variantInput && state.variant_id) variantInput.value = state.variant_id;
    var priceEl = root.querySelector('.bottom__controls .variant-price');
    var cents = a.getAttribute('data-price');
    if (priceEl && cents) { priceEl.textContent = formatPrice(cents) + ' €'; priceEl.dataset.price = cents; }
    syncStageToSize();
  }
  /* Holzrahmen-Vorschau: bei Typ "Poster im Holzrahmen" Frame an der Stage ein. */
  function updateFramePreview() {
    if (!stage) return;
    var framed = (state.product_type || '').indexOf('Holzrahmen') !== -1;
    if (framed) { stage.classList.add('has-frame'); stage.setAttribute('data-frame-color', state.frame_color || 'brown'); }
    else { stage.classList.remove('has-frame'); stage.removeAttribute('data-frame-color'); }
  }

  function initFormatPickers() {
    var typeLinks = root.querySelectorAll('.tab__switcher a[data-id]');
    var sizeLinks = root.querySelectorAll('.el__format .size__picker a[data-size]');
    var frameLinks = root.querySelectorAll('a[data-frame-color]');

    typeLinks.forEach(function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        typeLinks.forEach(function (x) { x.classList.remove('current'); });
        a.classList.add('current');
        state.product_type = a.getAttribute('data-type') || '';
        var typeId = a.getAttribute('data-id');
        updateFramePreview();
        root.querySelectorAll('.el__format').forEach(function (f) {
          f.style.display = (f.getAttribute('data-id') === typeId) ? '' : 'none';
        });
        root.querySelectorAll('.benefits-box').forEach(function (b) {
          b.style.display = (b.getAttribute('data-id') === typeId) ? '' : 'none';
        });
        // Größe im neuen Format übernehmen: gewünschte behalten, sonst current/erste
        var fmt = root.querySelector('.el__format[data-id="' + typeId + '"]');
        if (!fmt) return;
        var ziel = fmt.querySelector('.size__picker a[data-size="' + state.paper_size + '"]') ||
                   fmt.querySelector('.size__picker a.current') ||
                   fmt.querySelector('.size__picker a[data-size]');
        if (ziel) {
          fmt.querySelectorAll('.size__picker a').forEach(function (l) { l.classList.remove('current'); });
          ziel.classList.add('current');
          syncVariantFromSize(ziel);
        }
      });
    });

    sizeLinks.forEach(function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        var picker = a.closest('.size__picker');
        picker.querySelectorAll('a').forEach(function (l) { l.classList.remove('current'); });
        a.classList.add('current');
        syncVariantFromSize(a);
      });
    });

    frameLinks.forEach(function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        frameLinks.forEach(function (x) { x.classList.remove('current'); });
        a.classList.add('current');
        state.frame_color = a.getAttribute('data-frame-color');
        updateFramePreview();
      });
    });

    // Initialzustand aus dem server-gerenderten Markup lesen
    var activeType = root.querySelector('.tab__switcher a.current[data-type]') || typeLinks[0];
    if (activeType) state.product_type = activeType.getAttribute('data-type') || '';
    var activeFrame = root.querySelector('a[data-frame-color].current');
    if (activeFrame) state.frame_color = activeFrame.getAttribute('data-frame-color');
    var visFormat = root.querySelector('.el__format[data-id="1"]');
    var activeSize = visFormat && (visFormat.querySelector('.size__picker a.current') || visFormat.querySelector('.size__picker a[data-size]'));
    if (activeSize) {
      if (!activeSize.classList.contains('current')) activeSize.classList.add('current');
      syncVariantFromSize(activeSize);
    }
    updateFramePreview();
  }

  /* Schriftart-Picker (Fotoposter-Pattern): EINE Auswahl für alle Textzeilen.
     state.texts[].font wird gesetzt → Payload trägt es, Server rendert 1:1. */
  function initFontPicker() {
    var links = root.querySelectorAll('.font-options-grid a[data-font]');
    links.forEach(function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        links.forEach(function (x) { x.classList.remove('current'); });
        a.classList.add('current');
        var font = a.getAttribute('data-font');
        state.texts.forEach(function (t, i) {
          t.font = font;
          var el = stage.querySelector('.text-slot[data-text-index="' + i + '"]');
          if (el) el.style.fontFamily = "'" + font + "', serif";
        });
        // Wort-Font bleibt FIX (Archivo Black) — Picker gilt nur für die Subline.
        // Eigene Wort-Font-Auswahl (3 kuratierte) evtl. später (Dominik 07.06.).
      });
    });
  }

  function initColorPicker() {
    const links = root.querySelectorAll('.blanket-color-picker .wrap a');
    const customInput = document.getElementById('wunschwort-custom-color-' + sectionId);
    function apply(hex) {
      state.bgColor = hex; state.design_color = hex;
      if (currentGrid) currentGrid.style.setProperty('--blanket-color', hex);
    }
    links.forEach(function (link) {
      link.addEventListener('click', function (e) {
        if (link.classList.contains('custom')) return;
        e.preventDefault();
        links.forEach(function (l) { l.classList.remove('current'); });
        link.classList.add('current');
        const c = link.getAttribute('data-color');
        if (c) apply(c);
      });
    });
    if (customInput) {
      let deb;
      customInput.addEventListener('input', function () {
        const self = this; const customLink = self.closest('a');
        if (customLink) { links.forEach(function (l) { l.classList.remove('current'); }); customLink.classList.add('current'); }
        clearTimeout(deb); deb = setTimeout(function () { apply(self.value); }, 120);
      });
    }
  }

  /* ===================================================================
   * Cart-Add — POSTERFLOW-Flow (photo.js-Pattern): Render-Job anstoßen,
   * _print_image_url + Config in die Order. KEIN _Provider (≠ MerchOne)!
   * =================================================================== */
  function parsePosterDim(label) {
    const m = /([0-9]+)\s*x\s*([0-9]+)/i.exec(label || '');
    return m ? { w: parseInt(m[1], 10), h: parseInt(m[2], 10) } : { w: 30, h: 40 };
  }

  async function handleCartAdd() {
    const cartBtn = document.getElementById('wunschwort-cart-btn-' + sectionId);
    if (!state.variant_id) { alert('Bitte wähle Produkt und Größe.'); return; }
    const filled = activeLayout.photos.map(function (_, i) { return i; }).filter(function (i) { return slotData[i] && slotData[i].user_image_url; });
    if (filled.length === 0) {
      alert('Bitte lade mindestens 1 eigenes Foto hoch.');
      return;
    }
    if (!state.word || !state.word.trim()) {
      alert('Bitte gib dein Wunschwort ein.');
      return;
    }
    cartBtn.disabled = true; cartBtn.textContent = 'Wird vorbereitet…';
    try {
      const jobId = (crypto && crypto.randomUUID) ? crypto.randomUUID() : (Date.now() + '-' + Math.random().toString(36).slice(2));

      // print-Block: Server liest NUR hieraus (nie aus dem Größen-Label) —
      // Orientierung ist pro Wort fix (LIEBE portrait, Rest landscape).
      const dim = parsePosterDim(state.paper_size);
      const longEdge = Math.max(dim.w, dim.h), shortEdge = Math.min(dim.w, dim.h);
      const isLandscape = false;   // Wunschwort ist immer Hochformat

      const photoSlotsOut = {};
      activeLayout.photos.forEach(function (ph, i) {
        photoSlotsOut['p' + (i + 1)] = {
          user_image_url: (slotData[i] && slotData[i].user_image_url) || '',
          crop: (slotData[i] && slotData[i].crop) || null
        };
      });
      const payload = {
        job_id: jobId,
        product: 'wunschwort',
        layout_id: layoutId,
        word: state.word,
        word_font: state.word_font,
        word_color: state.word_color,
        paper_size: state.paper_size,
        product_type: state.product_type,
        variant_id: state.variant_id,
        photo_slots: photoSlotsOut,
        // Texte MIT allen Style-Feldern — der Server rendert 1:1 (Editor=Print);
        // damit ist auch eine künftige Font-Auswahl automatisch druckfest.
        text_slots: state.texts.map(function (t) {
          return { content: t.content, x: t.x, y: t.y, font: t.font, size: t.size,
                   weight: t.weight, color: t.color, upper: !!t.upper, spacing: t.spacing || '' };
        }),
        bg_color: state.design_color,
        print: {
          width: isLandscape ? longEdge : shortEdge,
          height: isLandscape ? shortEdge : longEdge,
          dpi: 300,
          orientation: 'portrait'
        }
      };

      // Render-Trigger (Block 3): existiert noch nicht → 404 OK, Fallback-URL deterministisch.
      let printImageUrl = BACKEND_API_URL + '/api/v1/wunschwort/data/' + jobId + '/';
      try {
        const renderResp = await fetch(BACKEND_API_URL + '/api/v1/wunschwort/render/', {
          method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload),
        });
        if (renderResp.ok || renderResp.status === 202) {
          const rd = await renderResp.json().catch(function () { return {}; });
          printImageUrl = rd.print_image_url || printImageUrl;
        }
      } catch (e) { /* Backend Block 3 noch nicht live — Fallback bleibt */ }

      const cartProperties = {
        '_Letter Config JSON': JSON.stringify(payload),
        '_Wort': state.word,
        '_Product Type': state.product_type,
        '_Paper Size': state.paper_size,
        '_print_image_url': printImageUrl,
        '_job_id': jobId,
        // Cart-Vorschau (PROJ-72): persistentes Komposit vom Render-Worker
        '_preview_image_url': BACKEND_API_URL + '/media/blanket_renders/' + jobId + '_cartpreview.jpg',
      };
      // _Frame Color nur bei Holzrahmen (Exporteo-Partnumber-Rebuild braucht das)
      if (state.frame_color && state.product_type.indexOf('Holzrahmen') !== -1) {
        cartProperties['_Frame Color'] = state.frame_color;
      }
      // Cart-Properties IMMER _-geprefixt -> im Warenkorb versteckt (nur Name/Preis/Variante sichtbar)
      state.texts.forEach(function (t) {
        if (t.content) cartProperties['_' + (t.label || 'Text')] = t.content;
      });
      Object.keys(cartProperties).forEach(function (k) { if (!cartProperties[k]) delete cartProperties[k]; });

      // Sofort-Vorschau (PROJ-72): Schnappschuss der sichtbaren Stage in sessionStorage,
      // damit der Warenkorb das Motiv sofort zeigt. Helper ist fail-soft (max 2,5s),
      // der Kauf wird nie blockiert.
      await (window.kaSofortVorschau ? window.kaSofortVorschau(stage, jobId) : Promise.resolve());

      const cartResp = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(state.variant_id, 10), quantity: 1, properties: cartProperties }] }),
      });
      if (!cartResp.ok) throw new Error('Cart-Add HTTP ' + cartResp.status);

      let cartData = null;
      try {
        cartData = await cartResp.json();
        if (window.DLTrack && window.DLTrack.addToCart) window.DLTrack.addToCart(cartData);
      } catch (e) { /* skip tracking */ }

      // Pattern wie photo.js:1782 — theme.js-Listener erwarten detail.cart,
      // ohne detail werfen sie TypeErrors (QA-Befund PROJ-9, 2026-06-07)
      document.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { cart: cartData } }));
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer && typeof cartDrawer.show === 'function') cartDrawer.show();
      else window.location.href = '/cart';
    } catch (err) {
      console.error('[wunschwort] Cart-add failed', err);
      alert('Konnte nicht in den Warenkorb legen — ' + (err.message || 'Unbekannter Fehler'));
    } finally {
      cartBtn.disabled = false; cartBtn.textContent = 'In den Warenkorb';
    }
  }

  /* ===================================================================
   * Init
   * =================================================================== */
  function init() {
    root = document.querySelector('.wunschwort-customizer');
    if (!root) return;
    sectionId = root.dataset.sectionId;
    layoutId = root.dataset.layoutId || 'zwei';
    stage = document.getElementById('wunschwort-stage-' + sectionId);
    assets = { placeholder: root.dataset.assetPlaceholder };

    // Wort→Produkt-Mapping für den Picker (Liquid-JSON)
    try {
      const pj = document.getElementById('wunschwort-products-' + sectionId);
      if (pj) LAYOUT_PRODUCTS = JSON.parse(pj.textContent);
    } catch (e) { /* optional — Produkte existieren ggf. noch nicht */ }

    loadLayout(layoutId);
    buildLayoutPicker();
    buildPhotoControls();
    buildTextFields();
    initTabSwitching();
    initWeiterNav();
    initFormatPickers();
    initFontPicker();
    initColorPicker();

    const cartBtn = document.getElementById('wunschwort-cart-btn-' + sectionId);
    if (cartBtn) cartBtn.addEventListener('click', handleCartAdd);

    const currentSwatch = root.querySelector('.blanket-color-picker .wrap a.current[data-color]');
    if (currentSwatch) {
      const c = currentSwatch.getAttribute('data-color');
      if (c) { state.bgColor = c; state.design_color = c; if (currentGrid) currentGrid.style.setProperty('--blanket-color', c); }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
